import { Fragment, useEffect } from "react";
import "utils/styles/root.scss";
import "utils/styles/index.scss";
import 'suneditor/dist/css/suneditor.min.css';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, useNavigationType } from "react-router-dom";
import { AdminContainer } from "layouts/admin/layout";
import { ViewContainer } from "layouts/view/layout";
import {
  PageAdminLogin, PageAdminHome, PageAdminConfig, PageAdminSpecialty, PageAdminSpecialtyCreate,
  PageViewContact, PageViewHome, PageViewSpecialty, PageViewIntroduce,
  PageAdminSpecialtyUpdate,
  PageAdminRoleCreate,
  PageAdminRoleUpdate,
  PageAdminRole,
  PageAdminTopic,
  PageAdminTopicCreate,
  PageAdminTopicUpdate,
  PageAdminDepartment, PageAdminDepartmentCreate, PageAdminDepartmentUpdate,
  PageAdminPosition, PageAdminPositionCreate, PageAdminPositionUpdate,
  PageAdminPost,
  PageAdminPostCreate,
  PageAdminPostUpdate,
  PageAdminUser,
  PageAdminUserCreate,
  PageAdminUserUpdate,
  PageAdminPermission,
  PageAdminPermissionCreate,
  PageAdminPermissionUpdate,
  PageAdminPermissionContainer,
  PageAdminPermissionManager,
  PageAdminUserPermissionManager,
  PageAdminTimeFrame,
  PageAdminTimeFrameCreate,
  PageAdminTimeFrameUpdate,
  PageAdminBookingConfig,
  PageViewBooking,
  PageAdminBooking,
  PageAdminBookingCreate,
  PageAdminBookingUpdate,
  PageViewBookingAlert,
  PageViewOrganizationalStructure,
  PageAdminAbout,
  PageAdminProfile,
  PageViewService,
  PageAdminService,
  PageAdminServiceCreate,
  PageAdminServiceUpdate,
  PageAdminMessage,
  PageAdminMessageCreate,
  PageAdminMessageUpdate,
  PageAdminLibrary,
  PageAdminMissionVision,
  PageAdminNotification,
  PageAdminNotificationCreate,
  PageAdminNotificationUpdate
} from "layouts";
import axios, { AxiosRequestHeaders } from "axios";
import { store } from "store";
import { authLogout } from "store/auth";
import { apiAuthCheck, apiGetConfig } from "apis";
import useAppSelector from "hooks/useAppSelector";
import { AppMessage } from "components";
import moment from "moment";
import { CONST_DAY_NAMES, CONST_DAY_NAMES_SHORT, CONST_MONTH_NAMES, CONST_MONTH_NAMES_SHORT } from "utils";
import { PageViewPostDetail, PageViewPostList } from "layouts/view/pages/post";
import NotFound from "layouts/view/component/NotFound";
import { PageViewAbout, PageViewMissionVision } from "layouts/view/pages/about";
import { PageViewNotificationDetail } from "layouts/view/pages/notification";

moment.updateLocale("vi", {
  week: { dow: 1 },
  months: CONST_MONTH_NAMES,
  monthsShort: CONST_MONTH_NAMES_SHORT,
  weekdays: CONST_DAY_NAMES,
  weekdaysShort: CONST_DAY_NAMES_SHORT,
});
const App = () => {
  const tokenLocalStorge = localStorage.getItem("token");
  axios.defaults.headers["Content-Type"] = "application/json";
  axios.defaults.headers["Authorization"] = tokenLocalStorge ? `Bearer ${tokenLocalStorge}` : null;

  // axios.defaults.baseURL = "";
  axios.interceptors.request.use((v) => {
    /**
     *  Mặc định sẽ gửi token
     *    Nếu không cần gửi token thì khai báo vào CONST_APIS
     *
     *  Nếu mặc định không gửi token
     *    ...?.auth === true;
     *    => Nếu cần gửi token thì khai báo vào CONST_APIS
     */
    return {
      ...v,
      withCredentials: v.withCredentials === false ? false : true,
    };
  });
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      console.log("error", error)
      let response = error.response || {};
      switch (error.response?.status) {
        case 401:
          AppMessage.error({
            title: "Thông báo!",
            message: "Phiên làm việc đã hết hạn. Vui lòng đăng nhập lại để tiếp tục!",
          });
          store.dispatch(authLogout());
          break;
        case 403:
          AppMessage.error({
            title: "Thông báo!",
            message: "Bạn không có quyền thao tác. Vui lòng liên hệ quản trị viên!",
          });
          break;
        default:
          AppMessage.error({
            title: "Thông báo lỗi",
            message: response?.data?.message,
          });
          break;
      }
      return response;
    }
  );
  useEffect(() => {
    apiGetConfig();
  }, [])

  return (
    <Fragment>
      <Router>
        <ScrollRestoration />
        <Routes>
          <Route
            path="/administrator/login.html"
            element={<PageAdminLogin />}
          />
          <Route path="/administrator" element={<PageAdminPermissionContainer />}>

            {/* Quyền */}
            <Route path="permission.html" element={<PageAdminPermission />} />
            <Route path="permission/create.html" element={<PageAdminPermissionCreate />} />
            <Route path="permission/update/:id.html" element={<PageAdminPermissionUpdate />} />
          </Route>
          <Route path="/administrator" element={<AdminContainer />}>
            <Route path="" element={<PageAdminHome />} />
            <Route path="profile.html" element={<PageAdminProfile />} />


            {/* folder-explorer */}
            <Route path="library.html" element={<PageAdminLibrary />} />

            {/* Giới thiệu */}
            <Route path="about.html" element={<PageAdminAbout />} />
            <Route path="mission-vision.html" element={<PageAdminMissionVision />} />

            {/* Chuyên khoa */}
            <Route path="specialty.html" element={<PageAdminSpecialty />} />
            <Route path="specialty/create.html" element={<PageAdminSpecialtyCreate />} />
            <Route path="specialty/update/:id.html" element={<PageAdminSpecialtyUpdate />} />

            {/* Vai trò */}
            <Route path="role.html" element={<PageAdminRole />} />
            <Route path="role/create.html" element={<PageAdminRoleCreate />} />
            <Route path="role/update/:id.html" element={<PageAdminRoleUpdate />} />

            {/* Phòng ban */}
            <Route path="department.html" element={<PageAdminDepartment />} />
            <Route path="department/create.html" element={<PageAdminDepartmentCreate />} />
            <Route path="department/update/:id.html" element={<PageAdminDepartmentUpdate />} />

            {/* Chức danh */}
            <Route path="position.html" element={<PageAdminPosition />} />
            <Route path="position/create.html" element={<PageAdminPositionCreate />} />
            <Route path="position/update/:id.html" element={<PageAdminPositionUpdate />} />

            {/* Ngươi dùng */}
            <Route path="user.html" element={<PageAdminUser />} />
            <Route path="user/create.html" element={<PageAdminUserCreate />} />
            <Route path="user/update/:id.html" element={<PageAdminUserUpdate />} />
            <Route path="user/permission-manager/:id.html" element={<PageAdminUserPermissionManager />} />


            {/* Chủ đề */}
            <Route path="topic.html" element={<PageAdminTopic />} />
            <Route path="topic/create.html" element={<PageAdminTopicCreate />} />
            <Route path="topic/update/:id.html" element={<PageAdminTopicUpdate />} />

            {/* Bài viết */}
            <Route path="post.html" element={<PageAdminPost />} />
            <Route path="post/create.html" element={<PageAdminPostCreate />} />
            <Route path="post/update/:id.html" element={<PageAdminPostUpdate />} />


            {/* Khung giờ */}
            <Route path="time-frame.html" element={<PageAdminTimeFrame />} />
            <Route path="time-frame/create.html" element={<PageAdminTimeFrameCreate />} />
            <Route path="time-frame/update/:id.html" element={<PageAdminTimeFrameUpdate />} />


            <Route path="booking.html" element={<PageAdminBooking />} />
            <Route path="booking/create.html" element={<PageAdminBookingCreate />} />
            <Route path="booking/update/:id.html" element={<PageAdminBookingUpdate />} />
            <Route path="booking/config.html" element={<PageAdminBookingConfig />} />

            <Route path="permission.html" element={<PageAdminHome />} />
            <Route path="user.html" element={<PageAdminHome />} />
            <Route path="post.html" element={<PageAdminHome />} />
            <Route path="appointment.html" element={<PageAdminHome />} />
            <Route path="config.html" element={<PageAdminConfig />} />


            {/* Dịch vụ */}
            <Route path="service.html" element={<PageAdminService />} />
            <Route path="service/create.html" element={<PageAdminServiceCreate />} />
            <Route path="service/update/:id.html" element={<PageAdminServiceUpdate />} />

            {/* Tin nhắn */}
            <Route path="message.html" element={<PageAdminMessage />} />
            <Route path="message/create.html" element={<PageAdminMessageCreate />} />
            <Route path="message/update/:id.html" element={<PageAdminMessageUpdate />} />


            {/* Thông báo */}
            <Route path="notification.html" element={<PageAdminNotification />} />
            <Route path="notification/create.html" element={<PageAdminNotificationCreate />} />
            <Route path="notification/update/:id.html" element={<PageAdminNotificationUpdate />} />

            <Route path="*" element={<NotFound />} />
          </Route>

          <Route path="/dat-hen/phieu-hen/:id.html" element={<PageViewBookingAlert />} />
          <Route
            path="/"
            element={<ViewContainer />}
          >
            <Route path="" element={<PageViewHome />} />
            <Route path="/tong-quan.html" element={<PageViewAbout />} />
            <Route path="/tam-nhin-su-menh.html" element={<PageViewMissionVision />} />
            <Route path="/gioi-thieu.html" element={<PageViewIntroduce />} />
            <Route path="/chuyen-khoa.html" element={<PageViewSpecialty />} />
            <Route path="/lien-he.html" element={<PageViewContact />} />
            <Route path="/chuyen-khoa/bac-si.html" element={<div>Tất cả Bác sĩ chuyên khoa</div>} />
            <Route path="/chuyen-khoa/:code.html" element={<div>Chi tiết chuyên khoa</div>} />
            <Route path="/chuyen-khoa/:code/bac-si.html" element={<div>Bác sĩ chuyên khoa</div>} />
            <Route path="/chuyen-khoa/:code/hoi-dap.html" element={<div>Hỏi đáp chuyên khoa</div>} />
            <Route path="/dat-hen.html" element={<PageViewBooking />} />
            <Route path="/dat-hen/ket-qua/:id.html" element={<PageViewBookingAlert />} />
            <Route path="/tin-tuc.html" element={<PageViewPostList />} />
            <Route path="/tin-tuc/:id/:title.html" element={<PageViewPostDetail />} />
            <Route path="/thong-bao/:id/:title.html" element={<PageViewNotificationDetail />} />


            <Route path="/co-cau-to-chuc.html" element={<PageViewOrganizationalStructure />} />
            <Route path="/dich-vu.html" element={<PageViewService />} />

            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
    </Fragment>
  );
};
export default App;

const scrollPositions: Record<string, number> = {};

const ScrollRestoration = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") {
      // Back/Forward: khôi phục scroll
      const pos = scrollPositions[location.key];
      window.scrollTo(0, pos || 0);
    } else {
      // Push/Replace: luôn về đầu
      window.scrollTo(0, 0);
    }

    return () => {
      // Lưu lại scroll position khi rời khỏi trang
      scrollPositions[location.key] = window.scrollY;
    };
  }, [location, navigationType]);

  return null;
}